import styled from 'styled-components'

interface TableGrayProps {
  white?: boolean
}

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  background-color: #fff;
  overflow: hidden;
`

export const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

export const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
`

/* [수정] 상하 간격을 조정하여 전체 메인 컨테이너 역할 부여 */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 24px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background: #ffffff;
`

export const InputSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`

export const SectionFrame = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: stretch;
  gap: 30px;
`

export const SectionHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;

  &::before,
  &::after {
    content: '';
    height: 1px;
    flex: 1;
    background: var(--gray30, #e6e6e6);
  }
`

export const SectionMark = styled.div`
  display: none;
`

export const SectionTitle = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
`

export const SectionDivider = styled.div`
  display: none;
`

export const ResultOverview = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 26px;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

export const ResultColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`

export const ResultPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ProfitBox = styled.div`
  padding: 24px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: #fff;
`

export const ProfitBody = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 680px) {
    flex-direction: column;
  }
`

export const ProfitAmountColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`

export const ProfitDivider = styled.div`
  width: 1px;
  background-color: #e6e6e6;

  @media (max-width: 680px) {
    width: 100%;
    height: 1px;
  }
`

export const ProfitDetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1.5;
`

export const ProfitStrongDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #333;
  margin: 4px 0;
`

export const ProfitTotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-weight: 700;
  font-size: 1.05rem;

  span:first-child {
    color: #333;
  }

  span:last-child {
    color: #57c9a7;
    text-align: right;
  }
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const DetailSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: 100%;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const DetailFullWidth = styled.div`
  grid-column: 1 / -1;
`

/* =======================================
   상단 컨트롤 영역
======================================= */
export const TopControls = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap; /* 창이 좁아지면 아래로 떨어지게 설정 */
  align-items: flex-end;
`

export const ControlItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RightAlignedControls = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: flex-end;
  margin-left: auto;
`

export const NumberInput = styled.input`
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  outline: none;
  font-family: SUIT;
  &:focus {
    border-color: #57c9a7;
  }
`

/* =======================================
   테이블 및 컨텐츠 아이템 영역
======================================= */
export const MiddleItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
`

export const MiddleItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #e6e6e6; /* 전체 테두리 추가 */
`

export const TableRow = styled.div`
  display: flex;
`
/* [수정] 하드코딩된 width를 지우고 flex로 비율 균등 분배 */
export const TableCell = styled.div<TableGrayProps & { flexWeight?: number }>`
  display: flex;
  flex: ${(props) => props.flexWeight || 1} 1 0%;
  box-sizing: border-box;

  min-width: 0;

  padding: 12px 0px;
  border-right: 0.5px solid #e6e6e6;
  border-bottom: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '#fff' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  text-align: center;
  word-break: keep-all;

  &:last-child {
    border-right: none;
  }
`
export const GraphBox = styled.div`
  height: 387px;
  width: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
`

export const ScrollTableBox = styled.div`
  width: 100%;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
`
